export const validateEmail = (param: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(param);
};

export const validateNumber = (param: string): boolean => {
  const numberRegex = /^[0-9]+$/;
  return numberRegex.test(param);
};
